import { render, staticRenderFns } from "./rgpd.vue?vue&type=template&id=14a84e6e&"
import script from "./rgpd.vue?vue&type=script&lang=js&"
export * from "./rgpd.vue?vue&type=script&lang=js&"
import style0 from "./rgpd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports